<div class="container">
  <app-breadcrumb
    currentPage="Minhas Fichas"
    routerCurrentPage="/ficha"
  ></app-breadcrumb>
  <main id="main-container" class="main">
    <section class="col-xs-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
      <app-tipo-pessoa
        [tipoCliente]="tipoPessoalSelecionado"
        [initialTipoPessoa]="initialTipoPessoa"
        [tiposClientes]="tiposPessoas"
        (tipoPessoaChange)="onTipoClienteChange($event)"
        *ngIf="shouldShowTipoPessoa"
      ></app-tipo-pessoa>

      <ng-container *ngIf="tipoCliente">
        <app-tipo-operacao
          [initialTipoProduto]="initialTipoProduto"
          (dadosSelecionados)="onDadosOperacaoChange($event)"
        ></app-tipo-operacao>

        <ng-container *ngIf="showProdutos">
          <app-tipo-veiculo
            *ngIf="isShowTipoVeiculo"
            [dadosOperacao]="dadosOperacao"
            [initialTipoVeiculo]="initialTipoVeiculo"
            (tipoVeiculoChange)="onTipoVeiculoChange($event)"
          ></app-tipo-veiculo>
        </ng-container>

        <app-quem-solicitou
          *ngIf="isShowSolicitante"
          [initialSolicitante]="initialSolicitante"
          (solicitanteChange)="onSolicitanteChange($event)"
        ></app-quem-solicitou>
      </ng-container>
    </section>

    <a
      *ngIf="tipoCliente"
      class="bt-go btn btn-full-orange main__next"
      [ngClass]="{ disabled: !isNext }"
      (click)="onclickNext()"
      >Continuar
      <em class="fa fa-arrow-right mlBt"></em>
    </a>
  </main>
</div>
